import { FormControl, FormGroup, Validators } from '@angular/forms';

export class VerifyCodeForm extends FormGroup {
  constructor() {
    super({
      verificationState: new FormControl('', [Validators.required]),
      email: new FormControl('', [Validators.required, Validators.email])
    });
  }

  get verificationState(): FormControl {
    return this.get('verificationState') as FormControl;
  }

  get email(): FormControl {
    return this.get('email') as FormControl;
  }
}
